import { BaseCouponsClient } from "../types/clients";
import { Coupon } from "@core/types";
import { ParhatoCoupon } from "./types";
import { convertParhatoCoupon } from "./converters";

class CouponsClient extends BaseCouponsClient {
  async getCoupon(code: string): Promise<Coupon | null> {
    const response = await this.instance.get<ParhatoCoupon[]>("/wp-json/wc/v3/coupons", {
      params: {
        code,
      },
    });

    if (response.data[0]) {
      return convertParhatoCoupon(response.data[0]);
    }

    return null;
  }
}

export default CouponsClient;
